/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from 'react';
import { Header as LuminateHeader } from '@walmart-dataventures/integrated-components';
import { PROJECTS, SHARED, MY_REPORTS_TAB_TEXT, SHARED_WITH_ME_TAB_TEXT } from 'constants/constant';
import bulletIcon from 'assets/svgs/bullet.svg';
import dashboardStyles from '../Dashboard.style';
import { useSelector, useDispatch } from 'react-redux';
import { UserPortalContext } from 'context/appcontext';
import { FEATURES } from 'helper/basicFeatureFlag';
import { colors } from 'theme/color-palette';
import { setTabValue } from '../Dashboard.actions';
import { Tabs, Tab } from '@material-ui/core';
import '@walmart-dataventures/integrated-components/dist/style.css';

const { LIGHTER_GREY, DARK_GREY } = colors;

function Header() {
	const classes = dashboardStyles();
	const dispatch = useDispatch();
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const sharedList = useSelector((state) => state.dashboardReducer.sharedList);
	const { DISABLE_SHARE_WITH_ME_TAB: disableShareTab } = FEATURES[customerType].DASHBOARD;
	const [selectedTabIndex, setSelectedTabIndex] = useState(0);
	useEffect(() => {
		dispatch(setTabValue(PROJECTS));
	}, []);

	const sharedLabel = () => {
		const check = sharedList.some((item) => {
			return item.downloadCount === undefined || item.downloadCount === 0;
		});

		return (
			<div style={{ display: 'flex', justifyContent: 'space-between' }} id="shared-tab">
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					{SHARED_WITH_ME_TAB_TEXT}
					{disableShareTab && (
						<div
							style={{
								background: LIGHTER_GREY,
								height: '17px',
								alignItems: 'center',
								display: 'flex',
								padding: '4px',
								margin: '0 8px'
							}}>
							<div style={{ color: DARK_GREY, fontSize: '12px' }}>Charter only</div>
						</div>
					)}
				</div>
				{check && (
					<div style={{ alignSelf: 'center', marginTop: '-20px' }}>
						<img className={classes.bullet} src={bulletIcon} alt="bullet-icon"></img>
					</div>
				)}
			</div>
		);
	};

	const TABS = [
		{
			label: MY_REPORTS_TAB_TEXT,
			value: PROJECTS,
			disabled: false
		},
		{
			label: sharedLabel(),
			value: SHARED,
			disabled: disableShareTab
		}
	];

	const handleTabChange = (index) => {
		setSelectedTabIndex(index);
		dispatch(setTabValue(TABS[index].value));
	};

	const TabsForReportBuilder = () => {
		return (
			<Tabs
				value={selectedTabIndex}
				classes={{
					root: classes.tabsRoot,
					indicator: classes.tabsIndicator
				}}
				indicatorColor="primary"
				onChange={(val, newVal) => {
					handleTabChange(newVal);
				}}>
				{TABS.map((item) => (
					<Tab
						id={item.label}
						label={item.label}
						key={item.label}
						classes={{ root: classes.tabRoot }}
						disabled={item.disabled}
					/>
				))}
			</Tabs>
		);
	};

	return (
		<>
			<LuminateHeader
				title="Report Builder"
				showLogo
				basePathDefined
				useWindowRedirection
				logoLabel="Report-Builder"
			/>
			<TabsForReportBuilder />
		</>
	);
}

export default React.memo(Header);
